function getParameterByName(a, b) {
    b || (b = window.location.href), a = a.replace(/[\[\]]/g, "\\$&");
    var c = new RegExp("[?&]" + a + "(=([^&#]*)|&|#|$)"),
        d = c.exec(b);
    return d ? d[2] ? decodeURIComponent(d[2].replace(/\+/g, " ")) : "" : null
}

function detectIE() {
    var a = window.navigator.userAgent,
        b = a.indexOf("MSIE ");
    if (b > 0) return parseInt(a.substring(b + 5, a.indexOf(".", b)), 10);
    var c = a.indexOf("Trident/");
    if (c > 0) {
        var d = a.indexOf("rv:");
        return parseInt(a.substring(d + 3, a.indexOf(".", d)), 10)
    }
    var e = a.indexOf("Edge/");
    return e > 0 && parseInt(a.substring(e + 5, a.indexOf(".", e)), 10)
}

var scrollToElement = function(el, ms){
    var speed = (ms) ? ms : 600;
    $('html,body').animate({
        scrollTop: $(el).offset().top - 76
    }, speed);
}

function getPathFromUrl(a) {
    return a.split("?")[0]
}

function setCookie(a, b, c) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * c * 60 * 60 * 1e3);
    var e = "expires=" + d.toUTCString();
    document.cookie = a + "=" + b + "; " + e + ";path=/"
}

function getCookie(a) {
    for (var b = a + "=", c = document.cookie.split(";"), d = 0; d < c.length; d++) {
        for (var e = c[d];
            " " == e.charAt(0);) e = e.substring(1);
        if (0 == e.indexOf(b)) return e.substring(b.length, e.length)
    }
    return ""
}
var fixed_el = document.getElementById("header-fixed"),
    input_el = document.querySelector('.hRMenu input[type="text"]');
input_el.addEventListener("touchstart", function() {
    function a() {
        fixed_el.style.position = "", fixed_el.style.top = "", input_el.removeEventListener("blur", a)
    }
    fixed_el.style.position = "absolute", fixed_el.style.top = $(window).scrollTop() + "px", input_el.addEventListener("blur", a)
});
var headerTotalHeight = 0,
    topBarTotalHeight = 0;
getHeaderTopHeight = function() {
    var a = $(".faq-right-menu").outerHeight();
    headerTotalHeight = 1 == a ? $(".header-fixed").outerHeight() + 40 : $(".header-fixed").outerHeight()
}, equalheight = function(a) {
    var e, b = 0,
        c = 0,
        d = new Array;
    $(a).each(function() {
        if (e = $(this), $(e).height("auto"), topPostion = e.position().top, c != topPostion) {
            for (currentDiv = 0; currentDiv < d.length; currentDiv++) d[currentDiv].height(b);
            d.length = 0, c = topPostion, b = e.height(), d.push(e)
        } else d.push(e), b = b < e.height() ? e.height() : b;
        for (currentDiv = 0; currentDiv < d.length; currentDiv++) d[currentDiv].height(b)
    })
};
var addPaddingBody = function() {
        setTimeout(function() {
            $("body").css("padding-top", $(".headerSec").outerHeight())
        }, 350)
    },
    condenseHeader = function() {
        $(window).width() >= 1024 && ($(window).scrollTop() >= 95 ? ($("body").hasClass("condense-header") ? "" : $("body").addClass("condense-header"), $("body").hasClass("normalHeader") ? $("body").removeClass("normalHeader") : "", $("body").find(".faq-right-menu").length > 0 ? $(".faq-sticky-header").show() : $(".faq-sticky-header").hide()) : ($("body").hasClass("condense-header") ? $("body").removeClass("condense-header") : "", $("body").hasClass("normalHeader") ? "" : $("body").addClass("normalHeader"), $("body").find(".faq-right-menu").length > 0 ? $(".faq-sticky-header").hide() : ""), addPaddingBody())
    },
    navStickyHeader = function() {
        $(window).width() >= 992 && ($(window).scrollTop() >= $(".header-offset").offset().top ? ($("body").hasClass("nav-fixed") ? "" : $("body").addClass("nav-fixed"), $(".header-offset").css("margin-bottom", headerTotalHeight - 40)) : ($("body").hasClass("nav-fixed") ? $("body").removeClass("nav-fixed") : "", $(".header-offset").css("margin-bottom", 0)), $("body").find(".faq-right-menu").length > 0 && (console.log($(window).scrollTop() + " " + $(".faq-page .faq-right-menu").offset().top), $(window).scrollTop() >= $(".faq-page .faq-right-menu").offset().top ? $(".faq-sticky-header").show() : $(".faq-sticky-header").hide()))
    },
    onScrollCondenseHeader = function() {
        $(window).width() >= 1024 && $(window).scroll(function() {
            navStickyHeader()
        })
    },
    backToTop = function() {
        $(window).scrollTop() >= 300 && $(".backToTop").css({
            visibility: "visible",
            opacity: "1"
        }), $(window).scroll(function() {
            $(window).scrollTop() >= 300 ? $(".backToTop").css({
                visibility: "visible",
                opacity: "1"
            }) : $(".backToTop").css({
                visibility: "hidden",
                opacity: "0"
            })
        })
    },
    procutPopUp = function() {
        var a = $(".productList").outerWidth();
        $(".productQuickView").css({
            width: a
        }), $(".productItem").each(function() {
            var a = $(".productList").offset(),
                b = $(this).offset();
            $(this).find(".productQuickView").css({
                left: a.left - b.left
            })
        })
    },
    recentlyViewedProducts = {
      totalProducts : 5,  
      wrapper: $('.recently-viewed'),
      get: function(){
        return localStorage.getItem('recentlyViewedProducts');
      },
      checkRVP: function(){
        var getCurrentRVP = this.get();

        if( getCurrentRVP && getCurrentRVP != "undefined" && getCurrentRVP != "" )
        {
          var currentRVPArr = getCurrentRVP.split(",");
          var currentRVPArrLength = currentRVPArr.length;
        }
        else
        {
          var currentRVPArr = "";
          var currentRVPArrLength = 0;
        }

        var returnObj = {
          "currentRVPArr" : currentRVPArr,
          "currentRVPArrLength" : currentRVPArrLength
        }
        return returnObj;
      },
      remove: function(productHandle){
        var checkRVPData = this.checkRVP();
        var currentRVPArr = checkRVPData.currentRVPArr;

        var index = currentRVPArr.indexOf(productHandle);  
        if (index > -1) {
          currentRVPArr.splice(index, 1);
        }

        localStorage.setItem('recentlyViewedProducts',currentRVPArr.join(","));
      },
      set: function(productHandle){
        //console.log("SET "+productHandle);

        var checkRVPData = this.checkRVP();
        var getCurrentRVP = checkRVPData.currentRVPArr;
        //console.log(checkRVPData.currentRVPArrLength);
        $el = this;
        if( getCurrentRVP && getCurrentRVP != "undefined" && getCurrentRVP != "" )
        {
          var currentRVPArr = getCurrentRVP;
          var currentRVPArrLength = checkRVPData.currentRVPArrLength;
          if( currentRVPArrLength > 6 )
            currentRVPArr = currentRVPArr.slice(0, 6);      

          if( $.inArray( productHandle , currentRVPArr ) != -1 )
          {
            var index = currentRVPArr.indexOf(productHandle);  
            if (index > -1) {
              currentRVPArr.splice(index, 1);
            }

            if( currentRVPArr.length == 6 ) 
                currentRVPArr.pop();

            if( currentRVPArrLength <= $el.totalProducts )
                currentRVPArr.unshift(productHandle);

          }
          else
          {
            if( currentRVPArr.length == 6 ) 
                currentRVPArr.pop();

            if( currentRVPArrLength <= $el.totalProducts )
                currentRVPArr.unshift(productHandle);
          }
          localStorage.setItem('recentlyViewedProducts',currentRVPArr.join(","));
        }
        else
        {
          localStorage.setItem('recentlyViewedProducts',productHandle); 
        }
        //console.log("GET "+this.get());
      },
      create: function(){
        var checkRVPData = this.checkRVP();
        var currentRVPArr = checkRVPData.currentRVPArr;
        var currentRVPArrLength = checkRVPData.currentRVPArrLength;
        var showErrorMessage = 1;
        var $el = this;
        //console.log("CREATE "+currentRVPArr);
        if( currentRVPArrLength > 0 )
        {
            $('.recently-viewed-loading').show();
            for( var i = 0 ; i < currentRVPArrLength ; i++ )
            {
              if( currentRVPArr[i] != productHandle )
              {
                showErrorMessage = 0;
                $.ajax({
                   dataType: 'json',
                   async: false,
                   url: '/products/' + currentRVPArr[i] + '.js',
                   cache: false,
                   success: function(product) { 
                      var finalImage = "";

                      if( product.featured_image != "" )
                      {
                        var img_url = product.featured_image;
                        var img_url_first = img_url.substring(0, img_url.lastIndexOf('/'));
                        var index = img_url.lastIndexOf("/") + 1;
                        var filename = img_url.substr(index);
                        tempAr = filename.split('.');
                        finalImage = img_url_first+'/'+tempAr[0]+'_medium.'+tempAr[1];
                      }
                      var proPriceHtml = '';
                      var stockLeft = '';



                     var catList = '';                 
                     if(product.tags.length > 0)
                     {
                        catList += '<ul class="productCatList">';
                     }

                     for(var t =0; t<product.tags.length; t++)
                     {                 	  
                        switch(product.tags[t])
                        {
                          case "filter-metal-precious-metals":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+preciousMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;

                          case "filter-metal-fashion-metals":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+fashionMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;

                          case "filter-gemstone-gemstones":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+naturalMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;  
                        }
                     }

                     if(product.tags.length > 0)
                     {
                        catList += '</ul>';
                     }                


                     if($('.customer-logged-in').length > 0){	
                        proPriceHtml = '<div class="product-price">';
                        if(product.compare_at_price > product.price) { proPriceHtml += '<span class="sale-price"><strike>'+Shopify.formatMoney(product.compare_at_price_min)+'</strike></span>'; }
                        proPriceHtml += '<span class="original-price">'+Shopify.formatMoney(product.price)+'</span>';
                     }
                     if(product.variants[0].inventory_quantity <=5 )
                     {
                       stockLeft = "Only "+ product.variants[0].inventory_quantity +" Left!";
                     }
                     else
                     {
                       stockLeft = "";
                     }
                     /*$el.wrapper.append('<div><a href="'+product.url+'"><img src="'+finalImage+'" alt="'+product.title+'"><div class="pro-detail-name productId">Item #: '+product.handle+'</div>'+proPriceHtml+'</a></div>');*/

                     if(product.title.length > 40)
                     {
                        product_title = product.title.substring(0, 40) + "...";
                     }
                     else
                     {
                        product_title = product.title;
                     }                 

                     $el.wrapper.append('<div class="wrapper"><div class="wrapper-inner clearfix"><a href="'+product.url+'"><div class="recentview-container"><img src="'+finalImage+'" alt="'+product.title+'"></div><div class="name-stock-outer"><div class="item-name"><strong>Item #: '+product.handle+'</strong></div><div class="stock-left">'+stockLeft+'</div></div><div class="pro-detail-name productId">'+ product_title + '</div>'+proPriceHtml+'<div class="cat-list">'+catList+'</div></a></div></div>');
                   },
                   error: function(data) { 
                      $el.remove( currentRVPArr[i] );
                   }
                }); 
              }
            }

            $el.wrapper.on('init', function(event, slick){
              /*setTimeout(function(){ 
                equalheight('.equalheighttitle');
                equalheight('.equalheighttitlerelated');
                equalheight('.equalheight');
              },1000);

              setTimeout(function(){ 
                equalheight('.equalheighttitle');
                equalheight('.equalheighttitlerelated');            
                equalheight('.equalheight');

              },1500);

              setTimeout(function(){ 
                equalheight('.equalheighttitle');
                equalheight('.equalheighttitlerelated');
                equalheight('.equalheight');
              },2000);*/

            });

            $el.wrapper.slick({
                prevArrow:"<span class='slArrow slArrowPrev'><i class='fa fa-angle-left' aria-hidden='true'></span></i>",
                nextArrow:"<span class='slArrow slArrowNext'><i class='fa fa-angle-right' aria-hidden='true'></span></i>",
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                infinite: false,
                focusOnSelect: true,
                responsive: [
                        {
                          breakpoint: 992,
                          settings: {
                            slidesToShow: 3
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 541,
                          settings: {
                            slidesToShow: 1
                          }
                        }
                      ]
            });

            $('.recently-viewed-loading').hide();
            //console.log("Created");
        }
        if ( showErrorMessage )
        {
            $el.wrapper.after('<div class="no-recently-viewed-pro">You have not viewed any product yet!</div>');
            $('.recently-viewed-loading').hide();
        }
      }
    },
    relatedProducts = {
      wrapper: $('.related-products'),
      create: function(){
        var currentRLPArr = relatedProductsSKU.split(",");
        var currentRLPArrLength = currentRLPArr.length;
        var $el = this;
        if( currentRLPArrLength > 0 && relateProductsFlag ) // relateProductsFlag was set in product.liquid
        {
            $('.related-products-loading').show();
            $('.related-products').slick('slickRemove',0);
            for( var i = 0 ; i < currentRLPArrLength ; i++ )
            {
              var proHand = currentRLPArr[i].trim();

              if( proHand != productHandle )
              {
                $.ajax({
                   dataType: 'json',
                   //async: false,
                   url: '/products/' + proHand + '.js',
                   cache: false,
                   success: function(product) { 
                      var finalImage = "";
                      if( product.featured_image != "" )
                      {
                        var img_url = product.featured_image;
                        var img_url_first = img_url.substring(0, img_url.lastIndexOf('/'));
                        var index = img_url.lastIndexOf("/") + 1;
                        var filename = img_url.substr(index);
                        tempAr = filename.split('.');
                        finalImage = img_url_first+'/'+tempAr[0]+'_medium.'+tempAr[1];
                      }
                     var proPriceHtml = '';
                     var stockLeft = '';
                     var catList = '';    

                     if(product.tags.length > 0)
                     {                    
                        catList += '<ul class="productCatList">';

                     }

                     for(var t =0; t<product.tags.length; t++)
                     {            

                        switch(product.tags[t])
                        {
                          case "filter-metal-precious-metals":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+preciousMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;

                          case "filter-metal-fashion-metals":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+fashionMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;

                          case "filter-gemstone-gemstones":
                            catList += '<li class="productCatItem"><span class="productCatIcon"><img src="'+naturalMetalImg+'" alt="" width="27" height="25"></span></li>'
                          break;  
                        }
                     }

                     if(product.tags.length > 0)
                     {
                        catList += '</ul>';
                     }

                     if($('.customer-logged-in').length >0 ){
                        proPriceHtml = '<div class="product-price">';
                        if(product.compare_at_price > product.price) { proPriceHtml += '<span class="sale-price"><strike>'+Shopify.formatMoney(product.compare_at_price_min)+'</strike></span>'; }
                        proPriceHtml += '<span class="original-price">'+Shopify.formatMoney(product.price)+'</span>';
                     }

                     if(product.variants[0].inventory_quantity <=5 )
                     {
                       stockLeft = "Only "+ product.variants[0].inventory_quantity +" Left!";
                     }
                     else
                     {
                       stockLeft = "";
                     }

                     if(product.title.length > 40)
                     {
                        product_title = product.title.substring(0, 40) + "...";
                     }
                     else
                     {
                        product_title = product.title;
                     } 

                     $('.related-products').slick('slickAdd','<div class="wrapper"><div class="wrapper-inner clearfix rp-slide"><a href="'+product.url+'"><div class="recentview-container"><img src="'+finalImage+'" alt="'+product.title+'"></div><div class="name-stock-outer"><div class="item-name"><strong>Item #: '+product.handle+'</strong></div><div class="stock-left">'+stockLeft+'</div></div><div class="pro-detail-name productId">'+ product_title + '</div>'+proPriceHtml+'<div class="cat-list">'+catList+'</div></a></div></div>');	                 
                     //$('.related-products').slick('slickAdd','<div class="rp-slide"><a href="'+product.url+'"><img src="'+finalImage+'" alt="'+product.title+'"><div class="pro-detail-name productId">Item #: '+product.handle+'</div>'+proPriceHtml+'</a></div>');			 

                     /*$('.related-products').slick('slickAdd','<div class="rp-slide"><a href="'+product.url+'"><img src="'+finalImage+'" alt="'+product.title+'"><div class="pro-detail-name productId">'+product.title+'</div>'+proPriceHtml+'</a></div>');*/

                   },
                   error: function(data) { 
                      //$el.remove( currentRLPArr[i] );
                   }
                }); 
              }
            }

            $('.related-products-loading').hide();

        }
        else
        {
           $('.blank-related-slide').remove();
            $el.wrapper.after('<div class="no-recently-viewed-pro">There are no related products!</div>');
            $('.related-products-loading').hide();
        }
      }
    },
    mWprocutPopUp = function() {
        var a = $(".mmaIconsSec .row").outerWidth();
        $(".modal-why").css({
            width: a
        }), $(".mmaIconsSec .equalheight").each(function() {
            var a = $(".mmaIconsSec .row").offset(),
                b = $(this).offset(),
                c = $(this).outerWidth() / 2;
            $(this).find(".serviceBox .modal-why").css({
                left: a.left - b.left
            }), $(this).find(".mwArrow").css({
                left: b.left - a.left + c - 26
            })
        })
    },
    serviceBox = function() {};
$("html").hasClass("supports-touch") ? ($(".mmaIconsSec .serviceBoxInner").click(function() {
    $(this).parent(".serviceBox").hasClass("serviceBoxActive") ? ($(".modal-why").slideUp(), $(".serviceBox").removeClass("serviceBoxActive"), $(this).closest(".equalheight").removeClass("equalheightActive")) : ($(".modal-why").slideUp(), $(".serviceBox").removeClass("serviceBoxActive"), $(this).closest(".mmaIconsSec").find(".equalheight").removeClass("equalheightActive"), $(this).next(".modal-why").slideDown(), $(this).parent(".serviceBox").addClass("serviceBoxActive"), $(this).closest(".equalheight").addClass("equalheightActive"))
}), $("body").find(".mmaIconsSec .serviceBox").length > 0 && $(".mmaIconsSec .serviceBox").each(function() {
    $(this).find(".modal-why-inner").append('<div class="mwClose">+</div>')
}), $(".mwClose").click(function() {
    $(".modal-why").slideUp(), $(".serviceBox").removeClass("serviceBoxActive"), $(this).closest(".mmaIconsSec").find(".equalheight").removeClass("equalheightActive"), $(this).next(".modal-why").slideDown(), $(this).parent(".serviceBox").removeClass("serviceBoxActive"), $(this).closest(".equalheight").removeClass("equalheightActive")
})) : $(".mmaIconsSec .serviceBox").stop().hover(function() {
    $(".modal-why").stop().hide(), $(this).find(".modal-why").stop().slideDown(), $(this).addClass("serviceBoxActive"), $(this).closest(".equalheight").addClass("equalheightActive")
}, function() {
    $(".modal-why").stop().hide(), $(this).removeClass("serviceBoxActive"), $(this).closest(".equalheight").removeClass("equalheightActive")
}), $(document).scroll(function() {
    $(".searchFormSmall input").blur()
}), $(document).ready(function() {
    function goToByScroll(id) {
        id = id.replace("-link", ""), $("html,body").animate({
            scrollTop: eval($("#" + id).offset().top - headerTotalHeight - 15)
        }, "slow", "swing", function() {
            getHeaderTopHeight()
        })
    }
    var nVer = navigator.appVersion,
        nAgt = navigator.userAgent,
        browserName = navigator.appName,
        fullVersion = "" + parseFloat(navigator.appVersion),
        majorVersion = parseInt(navigator.appVersion, 10),
        nameOffset, verOffset, ix;
    (verOffset = nAgt.indexOf("Opera")) != -1 ? (browserName = "Opera", fullVersion = nAgt.substring(verOffset + 6), (verOffset = nAgt.indexOf("Version")) != -1 && (fullVersion = nAgt.substring(verOffset + 8))) : 0 != detectIE() ? browserName = "ie" : (verOffset = nAgt.indexOf("MSIE")) != -1 ? (browserName = "Microsoft Internet Explorer", fullVersion = nAgt.substring(verOffset + 5)) : (verOffset = nAgt.indexOf("Chrome")) != -1 ? (browserName = "Chrome", fullVersion = nAgt.substring(verOffset + 7)) : (verOffset = nAgt.indexOf("Safari")) != -1 ? (browserName = "Safari", fullVersion = nAgt.substring(verOffset + 7), (verOffset = nAgt.indexOf("Version")) != -1 && (fullVersion = nAgt.substring(verOffset + 8))) : (verOffset = nAgt.indexOf("Firefox")) != -1 ? (browserName = "Firefox", fullVersion = nAgt.substring(verOffset + 8)) : (nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/")) && (browserName = nAgt.substring(nameOffset, verOffset), fullVersion = nAgt.substring(verOffset + 1), browserName.toLowerCase() == browserName.toUpperCase() && (browserName = navigator.appName));
    var OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") != -1 && (OSName = "Windows"), navigator.appVersion.indexOf("Mac") != -1 && (OSName = "MacOS"), navigator.appVersion.indexOf("X11") != -1 && (OSName = "UNIX"), navigator.appVersion.indexOf("Linux") != -1 && (OSName = "Linux"), $("body").addClass(browserName.toLowerCase()).addClass(OSName.toLowerCase()), navigator.userAgent.match(/iP(hone|od|ad)/i) ? $("body").addClass("browser-ios") : $("body").addClass("not-ios"), mWprocutPopUp(), $(window).width() >= 992 && getHeaderTopHeight(), $(".customer-logged-in").length && $(".signToDownload").html('<a href="https://api.mmasilver.com/MMA_Social_Media_Images.zip" class="btn btn-default">Download Now</a>'), $(".hs_enable_mobile").html($(".topBar").html()), $(".productCopyMobile").html($(".productCopyDesktop").html()), $("nav#menu").mmenu({
            navbars: [{
                position: "top",
                content: ["prev", "title", "close"]
            }]
        }), procutPopUp(), $(".navbar .dropdown > a").click(function() {
            location.href = this.href
        }), 
        $("#buldiscountlink").click(function(){      	
            scrollToElement('.bulkDiscount', 1000);
        }),
        $(".smFilter > a").click(function() {
            $(".catLeft").toggleClass("catLeftActive")
        }), /*$(".bDTrigger,.bulkDiscount").hover(function() {
            $(".bulkDiscount").stop().slideDown()
        }, function() {
            $(".bulkDiscount").stop().slideUp()
        }),*/ $(".bulkDiscClose").click(function() {
            $(".bulkDiscount").stop().slideUp()
        }), $("body").on("click", ".faq-right-menu ul li a, .faq-sticky-header ul li a", function(a) {
            a.preventDefault(), goToByScroll($(this).attr("id"))
        }), $(".msg_head").click(function() {
            $(this).next(".msg_body").slideToggle(), $(this).parents(".faqList").toggleClass("active"), $(this).parents(".faqList").siblings(".faqList").removeClass("active"), $(this).parents(".faqList").siblings(".faqList").find(".msg_body").slideUp()
        }), $("body").on("click", ".faqList .close", function() {
            $(this).parent(".msg_body").slideUp(), $(this).parents(".faqList").removeClass("active")
        }), $("body").find(".faqList").length > 0 && $(".faqList").each(function() {
            $(this).find(".msg_body").append('<a class="close">+</a>')
        }), $("body").on("click", ".readMore", function() {
            var a = $(this);
            a.toggleClass("readMore"), a.hasClass("readMore") ? a.text("show more …") : a.text("show less …")
        }), $('body').on('click', '.quickShipBtn', function () {
      		
        var thatElem = $(this);      	
      	$('.productQuickView').hide();      	
         $(".productItem").removeClass("quick-view-openend").css('height','auto');        
         thatElem.closest('.productItem').addClass("quick-view-openend");        
      	
      	  var currentProItem = $(this).closest('.productItem');
      	
          $('.productItem').not(currentProItem).each(function(){
            if($(this).find('.productSlider').hasClass('slick-slider')){
                $(this).find('.productSlider').slick('unslick');
                $(this).find('.productSliderNav').slick('unslick');
            } 
          }); 
      
      
      	 if( $(window).width() < 767){
          minusoffset = 6;
          setTimeout(function(){         	            
              scrolloffset = thatElem.closest('.productItem').offset().top;           
			  var currentOpenObj =  thatElem.closest('.productItem');            
              var body = $("html, body");              
              var detectPartial =  'complete';
			  var isVisibleContainer = $('.productItem.quick-view-openend .openproductQuickView .productQuickViewinner').visible( detectPartial );
            
            
            if(!isVisibleContainer){
              var sclTopPos = currentOpenObj.offset().top + (currentOpenObj.height() / 2); 
              sclTopPos = sclTopPos - ($(window).height() / 2);
              body.stop().animate({scrollTop: sclTopPos }, '50', 'swing', function() { 

              });
            }
          },50); 
        }
      
      	
        $(this).closest('.productItem').find('.productQuickView').show().addClass("openproductQuickView");      
      
      	$(this).closest('.productItem').find('.pqvRight .add-to-cart-errors').html('').hide();
      	$(this).closest('.productItem').find('.pqvRight .add-to-cart-success').html('').hide();
      	var $mainSlider = $(this).closest('.productItem').find('.productSlider');
        var $navSlider = $(this).closest('.productItem').find('.productSliderNav');
      
      	
      	if($navSlider.length == 0)
        {
        	$(this).closest('.productItem').find('.productQuickView').addClass("sliderwithnav");  
        }
        var $zoomImageMMA = $(this).closest('.productItem').find('img.zoom-image-mma');
      	//  Initialize the slider if not initialized yet
      	if( !$(this).closest('.productItem').find('.productSlider').hasClass('slick-slider') )
        {
      
         	$mainSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: $navSlider,
              	centerMode: true,
              	infinite: true
            });
            $navSlider.slick({
                prevArrow:"<span class='slArrow slArrowPrev'><i class='fa fa-angle-up' aria-hidden='true'></span></i>",
                nextArrow:"<span class='slArrow slArrowNext'><i class='fa fa-angle-down' aria-hidden='true'></span></i>",
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: $mainSlider,
                dots: false,
                infinite: true,
                focusOnSelect: true,
                vertical: false,
                responsive: [
                      {
                        breakpoint: 767,                                        		
                        settings: {
                          prevArrow:"<span class='slArrow slArrowPrev'><i class='fa fa-angle-left' aria-hidden='true'></span></i>",
                		  nextArrow:"<span class='slArrow slArrowNext'><i class='fa fa-angle-right' aria-hidden='true'></span></i>",
                          vertical: true,
                          slidesToShow: 2,
                        }
                      }
                    ]
            });           
        }
      	/*else
        {
          	$mainSlider.slick('reinit');
      		$navSlider.slick('reinit');
        }*/
      
      	equalheight('.equalheight');        
    	}), $(".pqvClose").click(function() {
            $('.productQuickView').hide(); 
            setTimeout (function(){
                $(window).resize();
            },100);

           $(this).closest(".productItem").removeClass("quick-view-openend");
        }), $(".productSliderDetail").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            fade: !0,
            asNavFor: ".productSliderNavDetail"
        }), $(".productSliderNavDetail").slick({
            prevArrow: "<span class='slArrow slArrowPrev'><i class='fa fa-angle-left' aria-hidden='true'></span></i>",
            nextArrow: "<span class='slArrow slArrowNext'><i class='fa fa-angle-right' aria-hidden='true'></span></i>",
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: ".productSliderDetail",
            dots: !1,
            infinite: !1,
            focusOnSelect: !0
        }), $(".store-url-sign-in").click(function() {
            setCookie("redirectAfterLogin", currentPageUrl, 365)
        }), $("body").on("click", ".user-info-heading", function() {
            $(".user-action-dd").slideToggle()
        }), $("body").on("click", ".hRMenu .userIcon", function() {
            $(".userActionDD").slideToggle()
        }), $(".mobileArrow").click(function() {
            $(".dropdown-menu").hide(), $(this).closest(".dropdown").find(".dropdown-menu").toggle()
        }), $("body").on("click", ".searchIcon", function() {
            $(this).toggleClass("toggelSearchIcon"), $(".searchFormSmall .searchForm").toggleClass("toggelSearchForm"), $(".searchIcon .fa-search").toggleClass("fa-times")
        }), $("body").on("click", ".backToTop", function() {
            $("html,body").animate({
                scrollTop: 0
            }, 1e3)
        }), backToTop(), $("body").hasClass("template-collection")) {
      	
      	 $("body").on('click','.pQtyBtn',function(){            
          
          var $inputBox = $("#Quantity_"+$(this).attr("data-productid"));
          var qtyVal = $inputBox.val() * 1;      
          if( $(this).hasClass('pQtyBtnIncrease') )
          {
            qtyVal = qtyVal + 1;
          }
          else
          {
            qtyVal = qtyVal - 1;
          }

          if( qtyVal >= 1 )
          {           
            $inputBox.val(qtyVal);
            $(".productQty_"+$(this).attr("data-productid")).val(qtyVal);
          }
          else
          {
            $inputBox.val('1');            
            $(".productQty_"+$(this).attr("data-productid")).val('1');
          }      
          return false;
        }),
    
        $('.productQty').keyup(function(){
          if( $(this).val() <= 1 && $(this).val() != ""	)
            $(this).val('1');
        })
         
        currentPageUrl = getPathFromUrl(currentPageUrl);
        var splitUrl = currentPageUrl.split("/"),
            extraFilter = null == getParameterByName("sort_by") ? "" : "?sort_by=" + getParameterByName("sort_by");
        if ("" != splitUrl[5] && "undefined" != typeof splitUrl[5]) {
            var splitByPlus = splitUrl[5].split("+");
            $(".unique-filter-loop").each(function() {
                var a = $(this).attr("data-filter"),
                    b = "filter-" + a,
                    c = "data-" + a + "-tag",
                    d = splitUrl[5].split("+");
                $(this).hasClass("is-collapsable") && $(this).find(".accordion-body li.active").length > 0 && ($(this).find(".accordion-body").addClass("in"), $(this).find(".readMoreLink").removeClass("readMore").html("show less …"));
                for (var e = 0; e < splitByPlus.length; e++) splitByPlus[e].indexOf(b) !== -1 && d.splice(e, 1), "cat" == a && splitByPlus[e].indexOf("filter-type") !== -1 && d.splice(e, 1);
                $(this).find("li").each(function() {
                    var a = $(this).attr(c);
                    d.length > 0 ? $(this).hasClass("active") ? $(this).find("a").attr("href", d.join("+") + extraFilter) : $(this).find("a").attr("href", d.join("+") + "+" + a + extraFilter) : $(this).find("a").attr("href", a + extraFilter)
                })
            })
        } else "" != extraFilter && $(".unique-filter-loop").each(function() {
            $(this).find("li").each(function() {
                var a = $(this);
                a.find("a").attr("href", a.find("a").attr("href") + extraFilter)
            })
        })      
       
    }
    $("#create_customer").addClass("form-horizontal")
}), $(window).load(function() {
  	
  	$(".lazyloading").each(function(){
    	$(this).parents("a").removeClass("lazyloadcenter");
      	$(this).attr("src",$(this).attr("data-src"));      
      	var that = $(this);
      	setTimeout(function(){
        	that.closest(".productImage").height(that.closest(".productImage").width());      
      	},500);    
      	$(this).removeAttr("data-src");    
    }),
  
    mWprocutPopUp(), $(window).width() >= 992 && getHeaderTopHeight(), $("body").addClass("afterLoad"), procutPopUp(), navStickyHeader(), onScrollCondenseHeader(), equalheight(".equalheight"), $(".main-nav a").each(function() {
        $(this).attr("href") == location.pathname && ($(this).closest("li").removeClass("active").addClass("active"), $(this).closest(".dropdown-menu").length && $(this).closest(".dropdown").removeClass("active").addClass("active"))
    }), currentPageUrl.indexOf("/blogs/silver-stars-insider/") === -1 && currentPageUrl.indexOf("/blogs/silver-stars-insider") === -1 || ($('.main-nav a[href="/blogs/silver-stars-insider/"]').closest("li").removeClass("active").addClass("active"), $('.footer a[href="/blogs/silver-stars-insider/"]').closest("li").removeClass("active").addClass("active"), $('.main-nav a[href="/blogs/silver-stars-insider"]').closest("li").removeClass("active").addClass("active"), $('.footer a[href="/blogs/silver-stars-insider"]').closest("li").removeClass("active").addClass("active")), $(".footer a").each(function() {
        $(this).attr("href") == location.pathname && $(this).closest("li").addClass("active")
    }), window.location.pathname.indexOf("/products/") !== -1 && (recentlyViewedProducts.create(), recentlyViewedProducts.set(productHandle), relatedProducts.create()), $(".sortByItemUI li").each(function() {
        $(this).find("a:eq(0)").attr("href", $(this).find("a:eq(1)").attr("href"))
    })
}), $(window).resize(function() {
  	
  	$(".lazyloading").each(function(){          
        var that = $(this);
        setTimeout(function(){          
      	    that.closest(".productImage").height(that.closest(".productImage").width());                
        },500);                   
    }), 
  
  	$(".productSlider .slick-slide").each(function(){
      $(this).height($(this).width()); 
  	}),
    
    mWprocutPopUp(), procutPopUp(), navStickyHeader(), onScrollCondenseHeader(), equalheight(".equalheight"), $(window).width() >= 992 ? getHeaderTopHeight() : headerTotalHeight = 0
}), $(".cancelEdit").click(function() {
    if ($(window).width() <= 767) var headerHeight = 0;
    else var headerHeight = $(".header-fixed").outerHeight();
    $("html,body").animate({
        scrollTop: eval($(this).closest(".editAddressArea").offset().top - headerHeight)
    }, 500)
});